const BagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M12.5 3.75C12.279 3.75 12.067 3.6622 11.9107 3.50592C11.7545 3.34964 11.6667 3.13768 11.6667 2.91667V1.66667H8.33333V2.91667C8.33333 3.13768 8.24554 3.34964 8.08926 3.50592C7.93297 3.6622 7.72101 3.75 7.5 3.75C7.27899 3.75 7.06702 3.6622 6.91074 3.50592C6.75446 3.34964 6.66667 3.13768 6.66667 2.91667V1.66667C6.66667 0.7475 7.41417 0 8.33333 0H11.6667C12.5858 0 13.3333 0.7475 13.3333 1.66667V2.91667C13.3333 3.13768 13.2455 3.34964 13.0893 3.50592C12.933 3.6622 12.721 3.75 12.5 3.75ZM10.5917 11.15C10.1911 11.2877 9.75506 11.2818 9.35833 11.1333L0 8.01667V14.375C0 15.6417 1.025 16.6667 2.29167 16.6667H17.7083C18.975 16.6667 20 15.6417 20 14.375V8.01667L10.5917 11.15Z"
        fill="currentColor"
      />
      <path
        d="M20 4.79167V6.7L10.2 9.96667C10.1333 9.99167 10.0667 10 10 10C9.93333 10 9.86667 9.99167 9.8 9.96667L0 6.7V4.79167C0 3.525 1.025 2.5 2.29167 2.5H17.7083C18.975 2.5 20 3.525 20 4.79167Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BagIcon;
